"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTreemapStackedSeries = exports.getTreemapStackedSeriesDataWithMeasures = exports.getTreemapStackedSeriesDataWithViewBy = void 0;
var tslib_1 = require("tslib");
var sdk_ui_vis_commons_1 = require("@gooddata/sdk-ui-vis-commons");
var common_1 = require("../_util/common");
var isEqual_1 = tslib_1.__importDefault(require("lodash/isEqual"));
function getColorStep(valuesCount) {
    var MAX_COLOR_BRIGHTNESS = 0.8;
    return MAX_COLOR_BRIGHTNESS / valuesCount;
}
function gradientPreviousGroup(solidColorLeafs) {
    var colorChange = getColorStep(solidColorLeafs.length);
    return solidColorLeafs.map(function (leaf, index) { return (tslib_1.__assign(tslib_1.__assign({}, leaf), { color: sdk_ui_vis_commons_1.getLighterColor(leaf.color, colorChange * index) })); });
}
function getRootPoint(rootName, index, format, colorStrategy) {
    return {
        id: "" + index,
        name: rootName,
        color: colorStrategy.getColorByIndex(index),
        showInLegend: true,
        legendIndex: index,
        format: format,
    };
}
function getLeafPoint(stackByAttribute, parentIndex, seriesIndex, data, format, colorStrategy) {
    return {
        name: stackByAttribute.items[seriesIndex].attributeHeaderItem.name,
        parent: "" + parentIndex,
        value: common_1.parseValue(data),
        x: seriesIndex,
        y: seriesIndex,
        showInLegend: false,
        color: colorStrategy.getColorByIndex(parentIndex),
        format: format,
    };
}
function isLastSerie(seriesIndex, dataLength) {
    return seriesIndex === dataLength - 1;
}
function getTreemapStackedSeriesDataWithViewBy(dv, measureGroup, viewByAttribute, stackByAttribute, colorStrategy) {
    var roots = [];
    var leafs = [];
    var rootId = -1;
    var uncoloredLeafs = [];
    var lastRoot = null;
    var executionResultData = dv.rawData().twoDimData();
    var dataLength = executionResultData.length;
    var format = common_1.unwrap(measureGroup.items[0]).format; // this configuration has only one measure
    executionResultData.forEach(function (seriesItems, seriesIndex) {
        var currentRoot = viewByAttribute.items[seriesIndex].attributeHeaderItem;
        if (!isEqual_1.default(currentRoot, lastRoot)) {
            // store previous group leafs
            leafs.push.apply(leafs, gradientPreviousGroup(uncoloredLeafs));
            rootId++;
            lastRoot = currentRoot;
            uncoloredLeafs = [];
            // create parent for pasted leafs
            var lastRootName = lastRoot === null || lastRoot === void 0 ? void 0 : lastRoot.name;
            roots.push(getRootPoint(lastRootName, rootId, format, colorStrategy));
        }
        // create leafs which will be colored at the end of group
        uncoloredLeafs.push(getLeafPoint(stackByAttribute, rootId, seriesIndex, seriesItems[0], format, colorStrategy));
        if (isLastSerie(seriesIndex, dataLength)) {
            // store last group leafs
            leafs.push.apply(leafs, gradientPreviousGroup(uncoloredLeafs));
        }
    });
    return tslib_1.__spreadArrays(roots, leafs); // roots need to be first items in data to keep legend working
}
exports.getTreemapStackedSeriesDataWithViewBy = getTreemapStackedSeriesDataWithViewBy;
function getTreemapStackedSeriesDataWithMeasures(dv, measureGroup, 
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
stackByAttribute, colorStrategy) {
    var data = measureGroup.items.map(function (measureGroupItem, index) {
        return {
            id: "" + index,
            name: measureGroupItem.measureHeaderItem.name,
            format: measureGroupItem.measureHeaderItem.format,
            color: colorStrategy.getColorByIndex(index),
            showInLegend: true,
            legendIndex: index,
        };
    });
    dv.rawData()
        .twoDimData()
        .forEach(function (seriesItems, seriesIndex) {
        var colorChange = getColorStep(seriesItems.length);
        var unsortedLeafs = seriesItems.map(function (seriesItem, seriesItemIndex) {
            return {
                name: stackByAttribute.items[seriesItemIndex].attributeHeaderItem.name,
                parent: "" + seriesIndex,
                format: common_1.unwrap(measureGroup.items[seriesIndex]).format,
                value: common_1.parseValue(seriesItem),
                x: seriesIndex,
                y: seriesItemIndex,
                showInLegend: false,
            };
        });
        var sortedLeafs = unsortedLeafs.sort(function (a, b) { return b.value - a.value; });
        data = tslib_1.__spreadArrays(data, sortedLeafs.map(function (leaf, seriesItemIndex) { return (tslib_1.__assign(tslib_1.__assign({}, leaf), { color: sdk_ui_vis_commons_1.getLighterColor(colorStrategy.getColorByIndex(seriesIndex), colorChange * seriesItemIndex) })); }));
    });
    return data;
}
exports.getTreemapStackedSeriesDataWithMeasures = getTreemapStackedSeriesDataWithMeasures;
function getTreemapStackedSeries(dv, measureGroup, viewByAttribute, stackByAttribute, colorStrategy) {
    var data = [];
    if (viewByAttribute) {
        data = getTreemapStackedSeriesDataWithViewBy(dv, measureGroup, viewByAttribute, stackByAttribute, colorStrategy);
    }
    else {
        data = getTreemapStackedSeriesDataWithMeasures(dv, measureGroup, stackByAttribute, colorStrategy);
    }
    var seriesName = measureGroup.items
        .map(function (wrappedMeasure) {
        return common_1.unwrap(wrappedMeasure).name;
    })
        .join(", ");
    return [
        {
            name: seriesName,
            legendType: "point",
            showInLegend: true,
            data: data,
            turboThreshold: 0,
            seriesIndex: 0,
        },
    ];
}
exports.getTreemapStackedSeries = getTreemapStackedSeries;
//# sourceMappingURL=treemapChartSeries.js.map